module.exports = __webpack_public_path__ + "static/media/participant-register-demographics.c4263158.svg";